import React from 'react';
import { Row, Col, Space, Alert, Button, Typography, Form, DatePicker, TimePicker, InputNumber } from 'antd';
import useConfiguracionesAplicacion from '../../hooks/adminexamen/useConfiguracionesAplicacion';

const ConfiguracionesAplicacion = () => {

  const { form, onFinish, onFinishFailed, disabled } = useConfiguracionesAplicacion();

  const { Title } = Typography;
  
  return (
    <>
      <Title level={3}>Configuraciones para la aplicación del examen</Title>
      <Title level={4}>Iniciar sesión y responder materias</Title>

      <Form
        form={form}
        name="configuracion_aplicacion"
        wrapperCol={{
          span: 20,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >

        <div style={{ paddingLeft: 15 }}>
          
          <Col span={12} style={{marginBottom: 10}}>
            <Alert message="Fecha y horas en las que los aspirantes podrán acceder y realizar el examen." type="info" showIcon />
          </Col>
            
          <Row>
            <Space>
              <p>Fecha de acceso:</p>

              <Form.Item
                name="fecha_acceso_examen"
                rules={[
                  {
                    required: true,
                    message: "Por favor llena este campo."
                  }
                  // con "required true", si el campo queda vacío genera un error en onFinishFailed() y evita que los datos se envíen al backend
                ]}
              >
                <DatePicker disabled={disabled} />
              </Form.Item>

              <p>Hora inicial:</p>
              <Form.Item
                name="hora_inicial_acceso"
                rules={[
                  {
                    required: true,
                    message: "Por favor llena este campo."
                  }
                ]}
              >
                <TimePicker disabled={disabled}/>
              </Form.Item>

              <p>Hora final:</p>
              <Form.Item
                name="hora_final_acceso"
                rules={[
                  {
                    required: true,
                    message: "Por favor llena este campo."
                  }
                ]}
              >
                <TimePicker disabled={disabled}/>
              </Form.Item>

            </Space>
          </Row>
            
        </div>


        <br/>
        

        <Title level={4}>Registro de aplicación</Title>

        <Col span={12} style={{ marginBottom: 10 }}>
          <Alert message="Fecha y número de aplicación registrado para el aspirante cuando éste realice el examen." type="info" showIcon />
        </Col>
        
        <div style={{paddingLeft: 15}}>
        <Row>
          <Space>
        <p>Fecha de aplicación:</p>
        <Form.Item
          name="fecha_aplicacion"
          rules={[
            {
              required: true,
              message: "Por favor llena este campo."
            }
          ]}
        >
          <DatePicker disabled={disabled}/>
        </Form.Item>

        <p>Número de aplicación:</p>
        <Form.Item
          name="numero_aplicacion"
          rules={[
            {
              required: true,
              message: "Por favor llena este campo."
            },
          ]}
        >
          <InputNumber min={1} disabled={disabled}/>
        </Form.Item>
          </Space>
        </Row>
          
        </div>

        <Button type="primary" htmlType="submit">
          Guardar configuración
        </Button>
      </Form>
    </>
  );

}

export default ConfiguracionesAplicacion;